import styled from "styled-components";

const Wrapper = styled.div`
  .error-stack {
    width: 100%;
  }

  .toolbar {
    margin-bottom: 20px;
  }

  .heading-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .page-title {
    margin: 0;
  }

  .people-title {
    margin-top: 28px;
  }

  .form-row {
    display: flex;
  }

  .flex-field {
    flex: 1;
  }
`;

export default Wrapper;
